/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Jobticket_Order_DateInputs */



/**

* @param {Validation_Jobticket_Order_DateInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const validation_jobticket_order_date = /** @type {((inputs?: Validation_Jobticket_Order_DateInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Jobticket_Order_DateInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Sie können das Ticket frühstens zum 9. des Vormonats bestellen.")
});